module.exports = __webpack_public_path__ + "static/media/10_portrait.d18adfb2.jpg";